import MaterialsList from '../../components/materials/MaterialsList'
import { createApp } from 'vue';

if (document.getElementById('favorite-tips-and-materials')) {

    const app = createApp({
        components: {
            MaterialsList,
        },
        data() {
            return {
              user: Auth.user // Assuming you have imported Auth from somewhere
            };
          }
    });
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#favorite-tips-and-materials');
}